import { Form, Formik } from "formik";
import React, { useState } from "react";
import { IDropdownOption } from "../../../interfaces/IDropdownOption";
import LModal from "../LModal/LModal";
import ModalHeader from "../ModalHeader/ModalHeader";
import * as Yup from "yup";
import Input from "../../Forms/Input/Input";
import Dropdown from "../../Forms/Dropdown/Dropdown";
import Button from "../../Forms/Button/Button";
import AcknowledgementModal from "../AcknowledgementModal/AcknowledgementModal";
import { sendContactEmail } from "../../../../compare/api/endpoints/ApiEmail";
import { IContactDetails } from "../../../interfaces/IContactDetails";

type CallbackModalProps = {
    groupId?: string;
    contactDetails?: IContactDetails;
    isOpen: boolean;
    onClose: () => void;
};

const callBackTimes: IDropdownOption[] = [
    {
        label: "8:30AM to 11:30AM",
        value: "8:30AM to 11:30AM"
    },
    {
        label: "11:30AM to 1:30PM",
        value: "11:30AM to 1:30PM"
    },
    {
        label: "1:30PM to 5:00PM",
        value: "1:30PM to 5:00PM"
    },
    {
        label: "5:00PM to 7:00PM",
        value: "5:00PM to 7:00PM"
    }
];

const validationSchema = Yup.object().shape({
    firstName: Yup.string()
        .trim()
        .required("Please tell us your name so we can call you"),
    phoneNumber: Yup.string().trim().required("What number can we reach you on?")
    // email: Yup.string()
    //     .required("Please tell us your email, so we can get back to you.")
    //     .email("Please make sure your email is valid"),
});

const CallbackModal: React.FC<CallbackModalProps> = (props) => {
    const { groupId, contactDetails, isOpen, onClose } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [isAcknowledged, setIsAcknowledged] = useState(false);
    const [successState, setSuccessState] = useState(false);

    if (isAcknowledged) {
        return (
            <AcknowledgementModal
                isOpen={isAcknowledged && isOpen}
                hasSucceeded={successState}
                successContent="Thank you for your request. We aim to get back to you within 1 business day at the time you have specified."
                onClose={() => {
                    setIsAcknowledged(false);
                    if (successState) {
                        setSuccessState(false);
                        onClose();
                    }
                }}
            />
        );
    }

    return (
        <LModal
            Header={() => <ModalHeader onClose={onClose} title="Arrange a call" />}
            calcHeightMode="auto"
            width="normal"
            isOpen={isOpen}
            onClose={onClose}
            isLoading={isLoading}>
            {() => (
                <React.Fragment>
                    <p className="text-font-size-ml gap-l">
                        One of our friendly team can call you to discuss your quotes and
                        any questions.
                    </p>
                    <Formik
                        onSubmit={(values) => {
                            setIsLoading(true);
                            sendContactEmail({
                                Body: values.details,
                                ClientName: values.firstName,
                                Email: "",
                                Enquiry: "Client Callback",
                                GroupId: groupId,
                                Location: "Multi-compare - Callback",
                                Phone: values.phoneNumber,
                                Subject: "IMPORTANT: Customer Phone Call Request",
                                ContactTime: values.callbackTime
                            })
                                .then(() => {
                                    setIsLoading(false);
                                    setSuccessState(true);
                                })
                                .finally(() => setIsAcknowledged(true));
                        }}
                        initialValues={{
                            firstName: contactDetails?.name || "",
                            phoneNumber: contactDetails?.phoneNumber || "",
                            callbackTime: callBackTimes[0].value,
                            details: ""
                        }}
                        validationSchema={validationSchema}>
                        {({
                            values,
                            handleBlur,
                            handleChange,
                            touched,
                            errors,
                            isValid,
                            submitCount,
                            isSubmitting
                        }) => (
                            <Form>
                                <Input
                                    name="firstName"
                                    type="text"
                                    value={values.firstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Your name"
                                    hasError={touched.firstName && errors.firstName}
                                />
                                <Input
                                    name="phoneNumber"
                                    type="text"
                                    value={values.phoneNumber}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    label="Your phone number"
                                    placeholder="02712345678"
                                    hasError={touched.phoneNumber && errors.phoneNumber}
                                />
                                <Dropdown
                                    id="callbackTime"
                                    name="call-back-time"
                                    options={callBackTimes}
                                    selectedOptionId={values.callbackTime}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    title="Best time to call"
                                />
                                <Input
                                    name="details"
                                    type="textarea"
                                    value={values.details}
                                    label="Your question"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    className="gap-l"
                                />
                                <Button
                                    component="button"
                                    type="submit"
                                    size="m"
                                    variant="calltoaction"
                                    isDisabled={
                                        (!isValid || isSubmitting) && submitCount > 0
                                    }>
                                    Arrange Call
                                </Button>
                            </Form>
                        )}
                    </Formik>
                </React.Fragment>
            )}
        </LModal>
    );
};

export default CallbackModal;
